import { ContractType } from '../types/contractAnalyzer';

export interface DetectionResult {
  type: ContractType;
  confidence: number; // 0..1
  reasons: string[];
}

export function detectContractType(text: string): DetectionResult {
  const t = (text || '').toLowerCase();
  const reasons: string[] = [];

  // NEC3 indicators
  const necSignals = [
    /early\s+warning/,
    /compensation\s+event/,
    /risk\s+register/,
    /programme\b/,
    /adjudication/,
    /construction\s+act/,
    /pay\s+less\s+notice/,
    /option\s+[abcde]/,
    /secondary\s+option\s+x\d+/,
    /z\s+clauses?/
  ];
  const necHits = necSignals.filter((r) => r.test(t)).length;
  if (necHits >= 2) {
    if (necSignals[0].test(t)) reasons.push('Found "Early Warning"');
    if (necSignals[1].test(t)) reasons.push('Found "Compensation Event"');
    if (necSignals[2].test(t)) reasons.push('Found "Risk Register"');
    if (necSignals[3].test(t)) reasons.push('Found "Programme"');
    if (necSignals[4].test(t)) reasons.push('Found "Adjudication"');
    if (necSignals[5].test(t)) reasons.push('Found "Construction Act"');
    if (necSignals[6].test(t)) reasons.push('Found "Pay less notice"');
    return { type: 'NEC3', confidence: Math.min(0.9, 0.4 + necHits * 0.1), reasons };
  }

  // NDA indicators
  const ndaHits = [/non[-\s]?disclosure/, /confidentiality/, /recipient\s+shall/].filter((r) => r.test(t)).length;
  if (ndaHits >= 2) {
    return { type: 'NDA', confidence: 0.7, reasons: ['NDA indicators detected'] };
  }

  // SaaS indicators
  const saasHits = [/service\s+level|sla/, /uptime|availability/, /subscription|tenant/].filter((r) => r.test(t)).length;
  if (saasHits >= 2) {
    return { type: 'SaaS', confidence: 0.65, reasons: ['SaaS indicators detected'] };
  }

  // MSA indicators
  const msaHits = [/master\s+services?\s+agreement/, /statement\s+of\s+work|sow/].filter((r) => r.test(t)).length;
  if (msaHits >= 1) {
    return { type: 'MSA', confidence: 0.6, reasons: ['MSA indicators detected'] };
  }

  // JCT indicators (UK construction)
  const jctSignals = [
    /\bjct\b|joint\s+contracts\s+tribunal/,
    /relevant\s+events|relevant\s+matters/,
    /pay\s+less\s+notice|final\s+date\s+for\s+payment|interim\s+valuation/,
    /liquidated\s+damages|sectional\s+completion/,
    /architect\/contract\s+administrator|employer'?s\s+agent/,
    /design\s+and\s+build|standard\s+building\s+contract/
  ];
  const jctHits = jctSignals.filter((r) => r.test(t)).length;
  if (jctHits >= 2) {
    return { type: 'JCT', confidence: Math.min(0.85, 0.4 + jctHits * 0.12), reasons: ['JCT indicators detected'] };
  }

  return { type: 'Other', confidence: 0.3, reasons: [] };
}
